import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { IDebugLog, ILayerStage } from '@antv/l7-core';
// import TileLayer from '../tile/core/BaseLayer';
/**
 * Layer Model 初始化，更新，销毁
 */
export default class LayerModelPlugin {
  build(layer) {
    return _asyncToGenerator(function* () {
      // 更新Model 配置项 style options
      layer.prepareBuildModel();
      // 初始化 Model
      yield layer.buildModels();
    })();
  }
  initLayerModel(layer) {
    var _this = this;
    return _asyncToGenerator(function* () {
      yield _this.build(layer);
      layer.styleNeedUpdate = false;
    })();
  }
  prepareLayerModel(layer) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      yield _this2.build(layer);
      layer.styleNeedUpdate = false;
    })();
  }
  apply(layer) {
    var _this3 = this;
    layer.hooks.init.tapPromise('LayerModelPlugin', /*#__PURE__*/_asyncToGenerator(function* () {
      if (layer.getSource().isTile) {
        layer.prepareBuildModel();
        return;
      }
      layer.log(IDebugLog.BuildModelStart, ILayerStage.INIT);
      yield _this3.initLayerModel(layer);
      layer.log(IDebugLog.BuildModelEnd, ILayerStage.INIT);
    }));
    layer.hooks.beforeRenderData.tapPromise('LayerModelPlugin', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (flag) {
        if (!flag) {
          // TileLayer  不需要rebuilder
          return false;
        }
        if (layer.getSource().isTile) {
          return false;
        }
        layer.log(IDebugLog.BuildModelStart, ILayerStage.UPDATE);
        yield _this3.prepareLayerModel(layer);
        layer.log(IDebugLog.BuildModelEnd, ILayerStage.UPDATE);
        return true;
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
}